<form [formGroup]="messageForm" class="msg-form">

  <div class="form-sections">

    <section class="form-section">
      <!-- <div class="form-section-header">
      <h3 class="form-section-title">Tid & giltighet</h3>
    </div> -->
    <div class="form-panel-body">
      <div class="datetime-grid">
        <div class="datetime-dates">
          <div class="datetime-field">
            <div class="field-label-row">
              <span class="field-label">Visas från</span>
              @if (showErrors('validFrom') && errorMessage('validFrom')) {
                <span class="field-error">{{ errorMessage("validFrom") }}</span>
              }
            </div>
            <app-datetime-field
              [value]="message.validFrom"
              (valueChange)="onDateChange($event, 'validFrom')"
              (invalidChange)="onDateTextInvalid($event, 'validFrom')"
              placeholder="Nu"
              [disabled]="isReadOnly()">
            </app-datetime-field>
          </div>
          <div class="datetime-field">
            <div class="field-label-row">
              <span class="field-label">Visas till</span>
              @if (showErrors('validTo') && errorMessage('validTo')) {
                <span class="field-error">{{ errorMessage("validTo") }}</span>
              }
            </div>
            <app-datetime-field
              [value]="message.validTo"
              [min]="message.validFrom"
              (valueChange)="onDateChange($event, 'validTo')"
              (invalidChange)="onDateTextInvalid($event, 'validTo')"
              placeholder="Tills vidare"
              [disabled]="isReadOnly()">
            </app-datetime-field>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="form-section">
    <div class="form-section-header">
      <!-- <h3 class="form-section-title">
      Rubrik
      <span class="field-required" *ngIf="!isReadOnly()">*</span>
    </h3> -->
    <span class="field-label">Rubrik</span>
    @if (!isReadOnly()) {
      <span class="field-meta">{{ getCount("heading") }}/{{ maxLength.heading }}</span>
    }
  </div>
  <div class="form-panel-body form-panel-body--compact">
    <div class="form-field form-field--full">
      @if (showErrors('heading')) {
        <span class="field-error">{{ errorMessage("heading") }}</span>
      }
      @if (!isReadOnly()) {
        <textarea
          formControlName="heading"
          [ngClass]="{ 'error-input': showErrors('heading') }"
          class="expanding-textarea"
          id="headingDiv"
          [attr.maxlength]="maxLength.heading"
          (paste)="onTextboxPaste($event, 'heading', maxLength.heading, true)"
          (input)="onTextboxChange($event, 'heading', maxLength.heading, true)"
        (keydown)="limitUserInput($event, maxLength.heading)"></textarea>
      }
      @if (isReadOnly()) {
        <textarea
          formControlName="heading"
          class="expanding-textarea disabled"
          id="headingDiv2"
        readonly></textarea>
      }
    </div>
  </div>
</section>

<section class="form-section">
  <div class="form-section-header">
    <h3 class="form-section-title">Plats & berörda</h3>
  </div>
  <div class="form-panel-body">
    <div class="form-grid">
      <div class="form-field">
        <div class="field-label-row">
          <span class="field-label">Plats</span>
          @if (!isReadOnly()) {
            <span class="field-meta">{{ getCount("location") }}/{{ maxLength.location }}</span>
          }
        </div>
        @if (showErrors('location')) {
          <span class="field-error">{{ errorMessage("location") }}</span>
        }
        @if (!isReadOnly()) {
          <textarea
            [ngClass]="{ 'error-input': showErrors('location') }"
            contenteditable="true"
            class="expanding-textarea"
            id="locationDiv"
            [value]="this.messageForm.get('location')!.value || ''"
            [maxLength]="maxLength.location"
            (paste)="onTextboxPaste($event, 'location', maxLength.location, false)"
            (keyup)="onTextboxChange($event, 'location', maxLength.location, false)"
          (keydown)="limitUserInput($event, maxLength.location)"></textarea>
        }
        @if (isReadOnly()) {
          <textarea
            disabled
            contenteditable="false"
            [value]="this.messageForm.get('location')!.value || ''"
            class="expanding-textarea disabled"
          id="locationDiv2"></textarea>
        }
      </div>
      <div class="form-field">
        <div class="field-label-row">
          <span class="field-label">Berörda</span>
          @if (!isReadOnly()) {
            <span class="field-meta">{{ getCount("affects") }}/{{ maxLength.affects }}</span>
          }
        </div>
        @if (showErrors('affects')) {
          <span class="field-error">{{ errorMessage("affects") }}</span>
        }
        @if (!isReadOnly()) {
          <textarea
            [ngClass]="{ 'error-input': showErrors('affects') }"
            contenteditable="true"
            class="expanding-textarea"
            id="affectsDiv"
            [value]="this.messageForm.get('affects')!.value || ''"
            [maxLength]="maxLength.affects"
            (paste)="onTextboxPaste($event, 'affects', maxLength.affects, true)"
            (keyup)="onTextboxChange($event, 'affects', maxLength.affects, false)"
          (keydown)="limitUserInput($event, maxLength.affects)"></textarea>
        }
        @if (isReadOnly()) {
          <textarea
            disabled
            contenteditable="false"
            [value]="this.messageForm.get('affects')!.value || ''"
            class="expanding-textarea disabled"
          id="affectsDiv2"></textarea>
        }
      </div>
    </div>
  </div>
</section>

<section class="form-section form-section--pair">
  <div class="form-section-pair">
    <div class="form-section-pair-col">
      <div class="form-section-header">
        <h3 class="form-section-title">
          Mottagare
          @if (!isReadOnly()) {
            <span class="field-required">*</span>
          }
        </h3>
      </div>
      <div class="form-panel-body">
        <div class="option-chips recipient-chips">
          <button type="button" class="option-chip" [class.is-selected]="allPSelected" [disabled]="isReadOnly()" (click)="toggleAllPSelection()">
            <mat-icon>{{ allPSelected ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            Alla
          </button>
          @for (notifyGroup of notifyGroupsList; track notifyGroup) {
            <button
              type="button"
              class="option-chip"
              [class.is-selected]="notifyGroup.selected"
              [disabled]="isReadOnly()"
              (click)="togglePerOne(notifyGroup)">
              <mat-icon>{{ notifyGroup.selected ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
              {{ notifyGroup.displayName }}
            </button>
          }
          <span class="recipient-chips-divider" aria-hidden="true" title="Välj antingen SV/LF eller Övrigt"></span>
          <button type="button" class="option-chip" [class.is-selected]="variousSelected" [disabled]="isReadOnly()" (click)="toggleVarious()">
            <mat-icon>{{ variousSelected ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            Övrigt
          </button>
        </div>
      </div>
    </div>

    <div class="form-section-pair-divider" aria-hidden="true"></div>

    <div class="form-section-pair-col form-section-pair-col--notis">
      <div class="form-section-header">
        <h3 class="form-section-title">Notis</h3>
      </div>
      <div class="form-panel-body">
        <div class="option-chips">
          <button type="button" class="option-chip" [class.is-selected]="silentMtrp" [disabled]="isReadOnly()" (click)="onToggle('silentMtrp')">
            <mat-icon>{{ silentMtrp ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            Tyst notis
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="form-section">
  <div class="form-section-header">
    <h3 class="form-section-title">Innehåll</h3>
  </div>
  <div class="form-panel-body form-panel-body--stacked">
    <div class="form-field form-field--full">
      <div class="field-label-row">
        <span class="field-label">Händelse</span>
        @if (!isReadOnly()) {
          <span class="field-meta">{{ getCount("incident") }}/{{ maxLength.incident }}</span>
        }
      </div>
      @if (showErrors('incident')) {
        <span class="field-error">{{ errorMessage("incident") }}</span>
      }
      @if (!isReadOnly()) {
        <textarea
          [ngClass]="{ 'error-input': showErrors('incident') }"
          contenteditable="true"
          class="expanding-textarea"
          id="incidentDiv"
          [value]="this.messageForm.get('incident')!.value || ''"
          [maxLength]="maxLength.incident"
          (paste)="onTextboxPaste($event, 'incident', maxLength.incident, false)"
          (keyup)="onTextboxChange($event, 'incident', maxLength.incident, false)"
        (keydown)="limitUserInput($event, maxLength.incident)"></textarea>
      }
      @if (isReadOnly()) {
        <textarea disabled contenteditable="false" [value]="this.messageForm.get('incident')!.value || ''" class="expanding-textarea disabled" id="incidentDiv2"></textarea>
      }
    </div>

    <div class="form-field form-field--full">
      <div class="field-label-row">
        <span class="field-label">Åtgärd</span>
        @if (!isReadOnly()) {
          <span class="field-meta">{{ getCount("action") }}/{{ maxLength.action }}</span>
        }
      </div>
      @if (showErrors('action')) {
        <span class="field-error">{{ errorMessage("action") }}</span>
      }
      @if (!isReadOnly()) {
        <textarea
          [ngClass]="{ 'error-input': showErrors('action') }"
          contenteditable="true"
          class="expanding-textarea"
          id="actionDiv"
          [value]="this.messageForm.get('action')!.value || ''"
          [maxLength]="maxLength.action"
          (paste)="onTextboxPaste($event, 'action', maxLength.action, false)"
          (keyup)="onTextboxChange($event, 'action', maxLength.action, false)"
        (keydown)="limitUserInput($event, maxLength.action)"></textarea>
      }
      @if (isReadOnly()) {
        <textarea disabled contenteditable="false" [value]="this.messageForm.get('action')!.value || ''" class="expanding-textarea disabled" id="actionDiv2"></textarea>
      }
    </div>

    <div class="form-field form-field--full">
      <div class="field-label-row">
        <span class="field-label">Trafikinformation</span>
        @if (!isReadOnly()) {
          <span class="field-meta">{{ getCount("trafficInfo") }}/{{ maxLength.trafficInfo }}</span>
        }
      </div>
      @if (showErrors('trafficInfo')) {
        <span class="field-error">{{ errorMessage("trafficInfo") }}</span>
      }
      @if (!isReadOnly()) {
        <textarea
          [ngClass]="{ 'error-input': showErrors('trafficInfo') }"
          contenteditable="true"
          class="expanding-textarea"
          id="trafficInfoDiv"
          [value]="this.messageForm.get('trafficInfo')!.value || ''"
          [maxLength]="maxLength.trafficInfo"
          (paste)="onTextboxPaste($event, 'trafficInfo', maxLength.trafficInfo, false)"
          (keyup)="onTextboxChange($event, 'trafficInfo', maxLength.trafficInfo, false)"
        (keydown)="limitUserInput($event, maxLength.trafficInfo)"></textarea>
      }
      @if (isReadOnly()) {
        <textarea disabled contenteditable="false" [value]="this.messageForm.get('trafficInfo')!.value || ''" class="expanding-textarea disabled" id="trafficInfoDiv2"></textarea>
      }
    </div>

    <div class="form-field form-field--full">
      <div class="field-label-row">
        <span class="field-label">Prognos</span>
        @if (!isReadOnly()) {
          <span class="field-meta">{{ getCount("estimation") }}/{{ maxLength.estimation }}</span>
        }
      </div>
      @if (showErrors('estimation')) {
        <span class="field-error">{{ errorMessage("estimation") }}</span>
      }
      @if (!isReadOnly()) {
        <textarea
          [ngClass]="{ 'error-input': showErrors('estimation') }"
          contenteditable="true"
          class="expanding-textarea"
          id="estimationDiv"
          [value]="this.messageForm.get('estimation')!.value || ''"
          [maxLength]="maxLength.estimation"
          (paste)="onTextboxPaste($event, 'estimation', maxLength.estimation, false)"
          (keyup)="onTextboxChange($event, 'estimation', maxLength.estimation, false)"
        (keydown)="limitUserInput($event, maxLength.estimation)"></textarea>
      }
      @if (isReadOnly()) {
        <textarea disabled contenteditable="false" [value]="this.messageForm.get('estimation')!.value || ''" class="expanding-textarea disabled" id="estimationDiv2"></textarea>
      }
    </div>

    <div class="form-field form-field--full">
      <div class="field-label-row">
        <span class="field-label">Alternativa resvägar</span>
        @if (!isReadOnly()) {
          <span class="field-meta">{{ getCount("alternativeRoute") }}/{{ maxLength.alternativeRoute }}</span>
        }
      </div>
      @if (showErrors('alternativeRoute')) {
        <span class="field-error">{{ errorMessage("alternativeRoute") }}</span>
      }
      @if (!isReadOnly()) {
        <textarea
          [ngClass]="{ 'error-input': showErrors('alternativeRoute') }"
          contenteditable="true"
          class="expanding-textarea"
          id="alternativeRouteDiv"
          [value]="this.messageForm.get('alternativeRoute')!.value || ''"
          [maxLength]="maxLength.alternativeRoute"
          (paste)="onTextboxPaste($event, 'alternativeRoute', maxLength.alternativeRoute, false)"
          (keyup)="onTextboxChange($event, 'alternativeRoute', maxLength.alternativeRoute, false)"
        (keydown)="limitUserInput($event, maxLength.alternativeRoute)"></textarea>
      }
      @if (isReadOnly()) {
        <textarea contenteditable="true" [value]="this.messageForm.get('alternativeRoute')!.value || ''" class="expanding-textarea" id="alternativeRouteDiv2"></textarea>
      }
    </div>
  </div>
</section>

<section class="form-section">
  <div class="form-section-header">
    <h3 class="form-section-title">Övrigt</h3>
  </div>
  <div class="form-panel-body">
    <div class="option-chips option-chips--spaced-below">
      <button type="button" class="option-chip" [class.is-selected]="ticketCooperation" [disabled]="isReadOnly()" (click)="onToggle('ticketCooperation')">
        <mat-icon>{{ ticketCooperation ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
        Biljettsamverkan
      </button>
      <button type="button" class="option-chip" [class.is-selected]="replacementBusOrdered" [disabled]="isReadOnly()" (click)="onToggle('replacementBusOrdered')">
        <mat-icon>{{ replacementBusOrdered ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
        Ersättningsbussar beställda
      </button>
      <button type="button" class="option-chip" [class.is-selected]="replacementBusConfirmed" [disabled]="isReadOnly()" (click)="onToggle('replacementBusConfirmed')">
        <mat-icon>{{ replacementBusConfirmed ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
        Ersättningsbussar bekräftade
      </button>
    </div>

    <div class="form-field form-field--full">
      <div class="field-label-row">
        <span class="field-label">Kommentar</span>
        @if (!isReadOnly()) {
          <span class="field-meta">{{ getCount("body") }}/{{ maxLength.body }}</span>
        }
      </div>
      @if (showErrors('body')) {
        <span class="field-error">{{ errorMessage("body") }}</span>
      }
      @if (!isReadOnly()) {
        <textarea
          [ngClass]="{ 'error-input': showErrors('body') }"
          contenteditable="true"
          class="expanding-textarea"
          id="bodyDiv"
          [value]="this.messageForm.get('body')!.value || ''"
          [maxLength]="maxLength.body"
          (paste)="onTextboxPaste($event, 'body', maxLength.body, false)"
          (keyup)="onTextboxChange($event, 'body', maxLength.body, false)"
        (keydown)="limitUserInput($event, maxLength.body)"></textarea>
      }
      @if (isReadOnly()) {
        <textarea disabled contenteditable="false" [value]="this.messageForm.get('body')!.value || ''" class="expanding-textarea disabled" id="bodyDiv2"></textarea>
      }
    </div>
  </div>
</section>

</div>

</form>
